import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessPointBuildingsComponent } from './access-point-buildings.component';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { SortByModule } from 'src/app/libs/ui/pipes/sort-by/sort-by.module';
import { ControlDisabledDirectiveModule } from 'src/app/libs/ui/directives/control-disabled/control-disabled-directive.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AccessPointBuildingsComponent],
  imports: [
    CommonModule,
    SharedLayoutModule,
    MatSlideToggleModule,
    MatIconModule,
    ReactiveFormsModule,
    MatButtonModule,
    FormsModule,
    SharedLayoutModule,
    WithTooltipModule,
    SortByModule,
    ControlDisabledDirectiveModule,
    TranslateModule
  ],
  exports: [AccessPointBuildingsComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class AccessPointBuildingsModule {}
